// PaymentMethodModal/BasicInfoSection.tsx
import React from "react";
import { FormSectionProps } from "./type";

const BasicInfoSection: React.FC<FormSectionProps> = ({
  formData,
  onFormDataChange,
}) => {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Account Label
        </label>
        <input
          type="text"
          name="label"
          value={formData.label}
          onChange={(e) => onFormDataChange("label", e.target.value)}
          placeholder="e.g. My Primary Bank Account"
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#000200]"
          required
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Account Holder Name
        </label>
        <input
          type="text"
          name="accountHolderName"
          value={formData.details.accountHolderName}
          onChange={(e) =>
            onFormDataChange("accountHolderName", e.target.value, true)
          }
          placeholder="Full name as per bank records"
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#000200]"
          required
        />
      </div>
    </div>
  );
};

export default BasicInfoSection;
